import React, { useEffect } from 'react';
import { ConfigProvider, App as AntdApp } from 'antd';
import { RouterProvider } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import { router } from './routes/routes';
import { messageStore } from './store/MessageStore';
import { ImageViewerProvider } from './components/ImageViewerContext';
import './App.css';

const App = observer(() => {
  const { message } = AntdApp.useApp();

  // 初始化消息 API
  useEffect(() => {
    messageStore.setMessage(message);
  }, [message]);

  return (
    <RouterProvider
      router={router}
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true,
      }}
    />
  );
});

const AppWrapper = () => {
  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: '#1890ff',
        },
      }}
    >
      <AntdApp>
        <ImageViewerProvider>
          <App />
        </ImageViewerProvider>
      </AntdApp>
    </ConfigProvider>
  );
};

export default AppWrapper;
